import { CompassTheme } from '@circleci/compass';
// import css from '@emotion/css';
import _styled, { CreateStyled } from '@emotion/styled';

// export { css };

export const styled = _styled as CreateStyled<CompassTheme>;
